import React, { Component } from "react";
import { GlobalContext } from "../../../../../../utils/globalprovider.js";

import SubtitleRange from "./SubtitleRange";

class SubtitleSelectionMode extends Component 
{
    static contextType = GlobalContext;
    constructor(props) {
        super(props);

        this.state = {
            value: props.value || "current",
            applineonly : false,
        };

        this.rangeRef = React.createRef();
    }

    handleChange = (value) => {
        this.setState({ value });

        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };


    getValues()
    {
        switch (this.state.value)
        {
            case "current":
                return {subtitles: this.state.value, applineonly:this.state.applineonly};
                break;
            case "range":
                return {
                    subtitles: this.state.value,
                    applineonly:this.state.applineonly,
                    range: this.rangeRef.current.getValues(),
                };
                break;
            case "selected":
                return {subtitles: this.state.value, applineonly:this.state.applineonly};
                break;
            case "unselected":
                return {subtitles: this.state.value, applineonly:this.state.applineonly};
                break;

            
        }
    }

    renderOption(value, label) {
        const selected = this.state.value === value;

        return (
            <label
                key={value}
                onClick={() => this.handleChange(value)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "12px 16px",
                    marginBottom: "8px",
                    borderRadius: "8px",
                    border: selected
                        ? "1px solid #4ea1ff"
                        : "1px solid #505050",
                    background: selected
                        ? "#25486d"
                        : "#101010",
                    transition: "all 0.2s"
                }}
            >
                <input
                    type="radio"
                    checked={selected}
                    onChange={() => {}}
                    style={{
                        width: "18px",
                        height: "18px",
                        accentColor: "#4ea1ff",
                        marginRight: "14px"
                    }}
                />

                <span
                    style={{
                        color: selected ? "#ffffff" : "#dddddd",
                        fontSize: "12px",
                        fontWeight: selected ? "600" : "400"
                    }}
                >
                    {label}
                </span>
            </label>
        );
    }

    renderLineOnly()
    {

        if (!this.props.lineonly) 
            return (<></>);
        const tzone = this.context.language == "fr"?"Appliquer aux lignes sélectionnées":"Apply to selected lines only";
        return (
        <label
            style={{
                fontSize: "12px",
                textAlign: "left",
                marginBottom: "10px",
                display: "block",
                cursor: "pointer"
            }}
        >
            <input
                type="checkbox"
                checked={this.state.applineonly}
                onChange={(e) =>
                    this.setState({ applineonly: e.target.checked })
                }
                style={{
                    marginRight: 8,
                    accentColor: "#4ea1ff"
                }}
            />
            {tzone}
        </label>
        )
        
    }
    render() {

        const tzone = this.context.language == "fr"?"Appliquer à :":"Apply To";
        var tcurrent = this.context.language == "fr"?"Sous-titre en cours":"Current subtitle";
        tcurrent += this.context.language == "fr"?" (n°" + this.props.current +")":" (#" + this.props.current +")"

        const trange = this.context.language == "fr"?"Intervalle de sous-titres":"Subtitles range";
        var tselected = this.context.language == "fr"?"Sous-titre sélectionnés":"Selected subtitles";
        const count = this.props.subtitles.filter(item => item.selected === true).length;
        const uncount = this.props.subtitles.length - count
        tselected = tselected + " (" + count + ")";
        var tunselected = this.context.language == "fr"?"Sous-titre non sélectionnés":"Unselected subtitles";
        tunselected = tunselected + " (" + uncount + ")";

        



        return (
            <>
            <br/>
            <div
                style={{
                    width: "98%",
                    background: "#000000",
                    border: "1px solid #555",
                    borderRadius: "10px",
                    padding: "10px",
                    boxSizing: "border-box",
                    fontFamily: "Segoe UI, sans-serif",
                    marginBottom: "5px",
                }}
            >
                <div
                    style={{
                        color: "#cfcfcf",
                        fontWeight: "bold",
                        marginBottom: "12px",
                        fontSize: "12px"
                    }}
                >
                    {tzone}
                </div>

                {this.renderLineOnly()}


                {this.renderOption(
                    "current",
                    tcurrent
                )}

                {this.renderOption(
                    "range",
                    trange
                )}

                <SubtitleRange
                ref = {this.rangeRef}
                maxSubtitles = {this.props.subtitles.length}
                onChange = {e=>{
                    this.setState({value:"range"});
                    this.props.onChange();
                    }}/>


                {this.renderOption(
                    "selected",
                    tselected
                )}

                {this.renderOption(
                    "unselected",
                    tunselected
                )}
            </div></>
        );
    }
}

SubtitleSelectionMode.defaultProps = {
    lineonly: false
}

export default SubtitleSelectionMode;